import { ClientOrderTrackingShipmentFolder } from "@redotech/redo-model/views/folders";
import { ClientOrderTrackingShipmentView } from "@redotech/redo-model/views/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const getOrderTrackingViewsAndFolders = {
  name: "getOrderTrackingViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientOrderTrackingShipmentFolder),
    views: z.array(ClientOrderTrackingShipmentView),
  }),
};
